import { render, staticRenderFns } from "./orderlog.vue?vue&type=template&id=841a857a"
import script from "./orderlog.vue?vue&type=script&lang=js"
export * from "./orderlog.vue?vue&type=script&lang=js"
import style0 from "./orderlog.vue?vue&type=style&index=0&id=841a857a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports